<div class="form-header">
  <div *ngIf="edited.id && edited.id > 0">Edit 
    document</div>
  <div *ngIf="!edited.id || edited.id === -1">Add 
    document</div>
</div>
<div class="field" *ngIf="library && library.length > 0">
  <mat-form-field >
    <mat-label>Select from library:</mat-label>
    <mat-select [(ngModel)]="libraryId" (selectionChange)="onSelectFromLibrary($event.value)">
      <mat-option *ngFor="let document of library" [value]="document.id">
        {{document.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>


<form [formGroup]="documentForm" (ngSubmit)="onSubmitForm(documentForm)" >
  
<div class="dialog-container" >
  <div class="field" required>
    <mat-form-field >
      <mat-label>Name</mat-label>
      <textarea class="description-field" rows="1" columns="50" maxlength="512" matInput formControlName="name" name="name"></textarea>
    </mat-form-field>
  </div>
  <div class="field" required *ngIf="!isNote()">
    <mat-form-field >
      <mat-label>Link / URL</mat-label>
      <textarea class="description-field" rows="2" columns="50" maxlength="1024" matInput formControlName="url" name="url"></textarea>
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field >
      <mat-label>Authors</mat-label>
      <textarea class="description-field" rows="2" columns="50" maxlength="255" matInput formControlName="authors" name="authors"></textarea>
    </mat-form-field>
  </div>
  <div class="field" >
    <mat-form-field  *ngIf="!isNote()">
      <mat-label>Description</mat-label>
      <textarea class="description-field" rows="3" columns="50" maxlength="1024" matInput formControlName="description" name="description"></textarea>
    </mat-form-field>
    <mat-form-field *ngIf="isNote()">
      <mat-label >Note Text</mat-label>
      <textarea class="description-field" rows="6" columns="50" maxlength="1024" matInput formControlName="description" name="description"></textarea>
    </mat-form-field>
   
  </div>

  <div class="field" *ngIf="contextType === 'PATIENT'" >
      <mat-checkbox formControlName="note" name="note" (change)="toggleNote($event.checked)">Is Note?</mat-checkbox>
  </div>

  <div class="button-container">
    <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button color="primary" >Save</button>
    <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
  </div>
</div>

</form>